var ModalNotLS = {
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "Отсутствует LoadSheet"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button.btn.btn-warning.btn-lg", {
                        //id: "",
                        onclick: function () {
                          ModalContainerNotLS.close();
                          m.route(`/task/${m.route.param('taskId')}/info`)
                        }
                      }, "Ок")
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerNotLS = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerNotLS.container = document.querySelector('#ModalNotLS');
    if (!ModalContainerNotLS.container) {
      ModalContainerNotLS.container = document.createElement('div');
      ModalContainerNotLS.container.id = 'ModalNotLS';
      ModalContainerNotLS.container.hidden = true;
      document.body.appendChild(ModalContainerNotLS.container);
      m.mount(ModalContainerNotLS.container, m.component(ModalNotLS, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (title, message, buttons= null, idElement = null) {
    ModalContainerNotLS.container = document.querySelector('#ModalNotLS');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerNotLS.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerNotLS.removeAll = removeAll;
    if (ModalContainerNotLS.container) {
      // if(title){
      // document.getElementById("modalTitleLmc").innerHTML = title;
      // }
      // if(message){
      // document.getElementById("modalContentLmc").innerHTML = message;
      // }
      /*if(buttons){
          document.getElementById("modalButtons").innerHTML = "";
          document.getElementById("modalButtons").append(buttons);
      }*/


      ModalContainerNotLS.container.hidden = false;
    }
  },
  close: function () {
    ModalContainerNotLS.container.hidden = true;
  }
};
